import { Component, Inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { tap } from 'rxjs/operators';
import { Company } from 'src/app/core/models/company';
import { CompanyService } from 'src/app/core/services/company.service';
import { MODAL_DATA } from 'src/app/core/services/modal';
import { AmazonAdsService } from 'src/app/core/services/v2/amazon-ads.service';
import { BaseComponent } from 'src/app/core/infrastructure/classes/base-component';
import { ProcessingService } from 'src/app/core/services/processing.service';
import { HeaderService } from 'src/app/core/services/header.service';

export interface INoticeModalData {
  title?: string;
  message?: string;
  confirmText?: string | null;
  isConnectAmazonAds?: boolean;
  isRunForecast?: boolean;
}

@Component({
  selector: 'app-notice-modal',
  templateUrl: './notice-modal.component.html',
  styleUrls: ['./notice-modal.component.scss']
})
export class NoticeModalComponent extends BaseComponent implements OnInit {
  isSyncInProcess: boolean = false;

  get title(): string {
    return this.data?.title || 'Notice';
  }

  get messageText(): string {
    return this.data?.message || 'Make sure to connect with your Amazon Ads account first to use this feature.';
  }

  get confirmText(): string | null {
    return this.data?.confirmText || null;
  }

  get currentCompany(): Company {
    return this.companyService.currentCompany();
  }

  get isShowConnectAmazonAdsButton(): boolean {
    return this.data?.isConnectAmazonAds;
  }

  connectAmazonAds() {
    this.amazonAdsService.getOAuthUrl(this.currentCompany.companyKey)
      .pipe(
        tap(({redirectUrl}) => {
          if (redirectUrl) {
            window.location.href = redirectUrl;
          }
        })
      )
      .subscribe()
  }

  constructor(
    @Inject(MODAL_DATA) public data: INoticeModalData,
    public activeModal: NgbActiveModal,
    private amazonAdsService: AmazonAdsService,
    private companyService: CompanyService,
    private processingService: ProcessingService,
    private headerService: HeaderService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.processingService.processingStartedSync
      .pipe(this.autoCleanUp())
      .subscribe((data) => {
        this.isSyncInProcess = data;
      });

    this.processingService.processingStoppedSync
      .pipe(this.autoCleanUp())
      .subscribe((data) => {
        this.isSyncInProcess = data;
      });

    this.headerService
      .getCompany()
      .pipe(this.autoCleanUp())
      .subscribe((data) => {
        this.isSyncInProcess = !!data?.jobInitiator;
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onConfirm(): void {
    if (this.isSyncInProcess) {
      return;
    }

    if (!this.data.isConnectAmazonAds && !this.data.isRunForecast) {
      this.activeModal.close(true);
      this.headerService.requestToOpenSyncSubject.next();
      return;
    }

    if (this.data.isRunForecast) {
      this.activeModal.close(true);
      this.headerService.requestToOpenForecastSubject.next();
      return;
    }
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }
}
